import { useMemo } from "react";
import { useGetTenantTypesQuery } from "../redux/services/communicationApi";

const FALLBACK_OPTIONS = [
  { value: "student", label: "Student" },
  { value: "working professional", label: "Working Professional" },
];

export const useTenantTypeOptions = () => {
  const { data, isLoading } = useGetTenantTypesQuery();

  const options = useMemo(() => {
    if (!data?.options) return FALLBACK_OPTIONS;
    return data.options.map((opt) => ({
      value: opt.code,
      label: opt.label,
    }));
  }, [data]);

  return { options, isLoading };
};
